function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon/1-color/DIS_plus");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.75,5.25 L11.25,5.25 C11.6642136,5.25 12,5.58578644 12,6 C12,6.41421356 11.6642136,6.75 11.25,6.75 L6.75,6.75 L6.75,11.25 C6.75,11.6642136 6.41421356,12 6,12 C5.58578644,12 5.25,11.6642136 5.25,11.25 L5.25,6.75 L0.75,6.75 C0.335786438,6.75 0,6.41421356 0,6 C0,5.58578644 0.335786438,5.25 0.75,5.25 L5.25,5.25 L5.25,0.75 C5.25,0.335786438 5.58578644,0 6,0 C6.41421356,0 6.75,0.335786438 6.75,0.75 L6.75,5.25 Z",
  id: "path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon/1-color/DIS_plus",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#3B77D9",
  x: 0,
  y: 0,
  width: 24,
  height: 24,
  rx: 2.18181818
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "COLOR/-black",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#FFFFFF",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  mask: "url(#mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.000000, -3.000000)",
  id: "foundation/color/ui-greyscale/grey_3-#C2C6CC"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-9",
  stroke: "#FFFFFF",
  fill: "#FFFFFF",
  x: 0.5,
  y: 0.5,
  width: 17,
  height: 17
}))))));

var SvgDisPlus = function SvgDisPlus(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisPlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DIS_plus.5c72ac02.svg";
export { ForwardRef as ReactComponent };